module.exports = __webpack_public_path__ + "static/4-3f7d6a3abb7bbe4c80c4878a4f0a27c1.png";